import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { queryClient } from '@/api/react-query'
import { applicationQueryKey } from '@/api/financial/application/read-application'

export function useUpdatePerson(applicationKey: string, personKey: string) {
  return useMutation({
    mutationFn: async (body: Record<string, unknown>) => {
      await httpClient('financial').put(`/v1/person/${personKey}`, body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationQueryKey(applicationKey) })
    },
  })
}

export function useCompleteProponents(applicationKey: string) {
  return useMutation({
    mutationFn: async () => {
      await httpClient('financial').post(
        `/v1/application/${applicationKey}/proponents-data/complete`,
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationQueryKey(applicationKey) })
    },
  })
}

/** Atualiza qualquer pessoa da solicitação (estudante, responsável ou avalista). */
export function usePatchPerson(applicationKey: string) {
  return useMutation({
    mutationFn: async ({
      personKey,
      body,
    }: {
      personKey: string
      body: Record<string, unknown>
    }) => {
      await httpClient('financial').put(`/v1/person/${personKey}`, body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: applicationQueryKey(applicationKey) })
    },
  })
}
